import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Panel.module.scss';
import Button from '../../Button';
import ChevronDown from '../../../assets/svg/Feather/ChevronDown';
import ChevronRight from '../../../assets/svg/Feather/ChevronRight';
import noop from 'lodash-es/noop';

function PanelActions(props) {
  const doAction = (action) => () => {
    !props.show ? props.setShow(true) : noop();
    action.onClick();
  };

  return (
    <>
      {props.actions.map((action, i) => {
        return (
          <Button
            key={`${action.name}-${i}`}
            size={Button.SIZE.tiny}
            theme={Button.THEME.text}
            disabled={action.disabled}
            onClick={doAction(action)}
          >
            {action.name}
          </Button>
        );
      })}
    </>
  );
}

PanelActions.propTypes = {
  actions: PropTypes.array,
  setShow: PropTypes.func,
  show: PropTypes.bool,
};
export default function Panel(props) {
  const [show, setShow] = useState(true);
  const getClassName = () => {
    return [styles.panel, props.divider ? styles.divider : ''].join(' ');
  };

  const reactStyles = {
    children: {
      display: !show ? 'none' : 'block',
      paddingTop: props.title != null ? '12px' : '0',
    }
  }
  

  return (
    <div className={getClassName()}>
      <div className={styles.panelHeader}>
        <div className={styles.panelTitle}>
          <span className={styles.titleText}>{props.title}</span>
          { props.count != null ? (
            <span className={styles.countText}>({props.count})</span>
          ): null}
        </div>
        <div className={styles.actions}>
          {props.actions.length > 0 ? (
            <PanelActions actions={props.actions} show={show} setShow={setShow} />
          ) : null}
          {props.collapsible ? (
            <div className={styles.showIcon} onClick={() => setShow(!show)}>
              {!show ? (
                <ChevronRight color='#8e8e92' />
              ) : (
                <ChevronDown color='#8e8e92' />
              )}
            </div>
          ) : null}
        </div>
      </div>
      <div
        style={reactStyles.children}
        className={styles.panelContent}
      >
        {props.children}
      </div>
    </div>
  );
}

Panel.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.any,
  collapsible: PropTypes.bool,
  count: PropTypes.number,
  divider: PropTypes.bool,
  title: PropTypes.string,
};

Panel.defaultProps = {
  actions: [],
  divider: false
};
